
export class BaseSettings {
	timestamp = Math.floor( (new Date()).getTime()/1000 );

	favourite_teams = {};
	prefer_old_team_logos = false;

	theme_name = "default";

	stream_grid_view = false;
	stream_sort_by_time = true;

	use_layout_theater = false;
	show_leaderboard = false;

	autoplay_enabled = true;
	autoplay_muted = true;

	player_type = "clappr";
	player_layout = "single";

	show_live_scores = true;
	show_final_scores = false;
	delete_spoilers = false;
	show_sharing = true;
	turbo_edge = 13;

	//Debug / Experimentals
	remove_stream_time_limits = false;
}
